
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const doc: Operator = {
	id: 'doc',
	name: 'Doc',
	role: 'Defender',
	org: 'GIGN',
	squad: 'WOLFGUARD',
	ratings: {
		health: 3,
		speed: 1,
		difficulty: 1
	},
	meta: {
		gender: 'm',
		country: 'fr',
		season: 'Release',
		height: 177,
		weight: 74,
		price: {
			renown: 1000,
			r6credits: 0
		}
	},
	bio: {
		real_name: 'Gustave Kateb',
		birthplace: 'Paris, France'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="M73 73h204v204H73z" style="fill:#315978"></path><path d="M293.028 136.556h-69.812a61.8 61.8 0 0 0-11.273-11.014l14.084-4.986v-12.611l64.097-14.559-96.625-36.844v41.847l-7.813 2.81a12.4 12.4 0 0 0 1.813-6.459c0-6.904-5.596-12.5-12.5-12.5s-12.5 5.596-12.5 12.5c0 2.367.67 4.572 1.813 6.459l-7.813-2.81V56.542L59.874 93.386l64.097 14.559v12.611l14.084 4.986a61.8 61.8 0 0 0-11.273 11.014h-69.81v76h69.571c7.591 9.705 18.021 17.081 30.054 20.849a1938 1938 0 0 1 2.819 14.04c2.505 12.72 3.066 16.242 3.444 18.833a218 218 0 0 1 1.5 12.972l10.639 14.375 10.639-14.375c.255-2.995.702-7.504 1.5-12.972.378-2.591.939-6.114 3.444-18.833.696-3.533 1.65-8.327 2.819-14.04 12.033-3.769 22.463-11.144 30.054-20.849h69.571v-76z"></path><path d="M63.583 142.833h223.5v63.5h-223.5zm105.834 134.111 5.583 7.611 5.25-7.667a489 489 0 0 1 8-45.111l-26.611-.167a473 473 0 0 1 7.778 45.334m.139-170.055 5.444 1.93 5.278-1.93v6.792h-10.722zm17.305-.66v8.083l18.465 7.827 15.223-5.347v-13L272.049 92l-73.334-27.917v37.834zm-23.757 0v8.083l-18.465 7.827-15.222-5.347v-13L77.917 92l73.333-27.917v37.834z" style="fill:#fff"></path><circle cx="174.944" cy="94.528" r="7.361" style="fill:#fff"></circle><circle cx="175" cy="174.708" r="61.5"></circle><path d="M174.917 118.583c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56m0 105.5c-27.338 0-49.5-22.162-49.5-49.5s22.162-49.5 49.5-49.5 49.5 22.162 49.5 49.5-22.162 49.5-49.5 49.5" style="fill:#fff"></path><path d="M210 165.186h-25.769v-25.769h-18.462v25.769H140v18.462h25.769v25.769h18.462v-25.769H210z" style="fill:#fff"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-doc'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
